import React, { useState, useContext } from "react";
import Modal2 from "./../Shared/PopupModal/PopupModal";
import { Activity, currentRequestTimeStamp } from "../../Constants";
import { toast } from "react-toastify";
import { mailerAPI } from "../Freightrates1/Utility";
import Loader from "../Loader";
import Axios from "axios";
import { Urls } from "../../Urls";
import useViewOnlyAccess from "../../hooks/useViewOnlyAccess";
import { set } from "lodash";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";

const NewUpgradeModal = ({ screenName, moduleName, feature }) => {
  const { userDetails } = useContext(UserApiContext)
  const [show, setshow] = useState(false);
  const { loading, canAccess, canCreate, checkActionPermission, isRestricted, handleRestrictedClick } = useViewOnlyAccess('spot');
  const submitHandler = (e) => {
    var company_mail = userDetails?.email;
    var company_name = userDetails.company_name
      ? userDetails.company_name
      : userDetails.email
        ? userDetails.email.split("@")[1].split(".")[0]
        : ""
    Activity([
      {
        screen: screenName,
        module: moduleName,
        user_activity: `Request Access button clicked`,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    toast.success(
      " Your request has been noted , we will reach out to you shortly"
    );

    var emailBody = {
      activity: "Email Request",
      type: "superlaunch",
      mail_status: "Pending",
      from_email: "connect@logisticsnow.in",
      user_type: "company",
      cc: "connect@logisticsnow.in",
      subject: `Premium Access Request for ${feature}`,
      to_email: `${company_mail}`,
      Application_name: "lorri",
      module_name: "new enquiry",
      timestamp: currentRequestTimeStamp(),
      content: `<div>Dear ${userDetails?.user_name},
                <p>Your request has been noted, we will reach out to you shortly.</p>
                <br />
                <br />
                <p>Should you need any assistance or have a question, please email (associate@logisticsnow.in) or call +91-9867773508 / +91-9653620207 </p>
                <p>Warm Regards,<br/>Team LoRRI </p>
                </div>`,
    };

    mailerAPI(emailBody, setshow);
    const mailingList = [
      "raj@logisticsnow.in",
      "associate@logisticsnow.in",
      "team@logisticsnow.in",
      "smeet@thelogisticsnow.com",
    ];

    const getEmailBody = (receiveremail) => {
      let email_body = {
        activity: "Email Request",
        type: "superlaunch",
        mail_status: "Pending",
        from_email: "connect@logisticsnow.in",
        user_type: "company",
        cc: "connect@logisticsnow.in",
        subject: `Access Request by ${company_name}`,
        to_email: receiveremail,
        Application_name: "lorri",
        module_name: "new enquiry",
        timestamp: currentRequestTimeStamp(),
        content: `<div>Hello,
                    <p>${feature} in ${screenName} is been requested by ${company_name}</p>
                    <br />
                    <br />
                    </div>`,
      };
      return email_body;
    };
    mailingList.map((mail, index) => {
      Axios.post(Urls.logURL, getEmailBody(mail))
        .then((res) => { })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return (
    <>
      <Loader show={show} />

      <div className="mt-4 text-center">
        <div className="alert px-4 py-3" role="alert">
          <h5 className="mb-3" style={{ fontSize: "16px" }}>
            Your subscription does not include this service or you have
            insufficient credits in your account.
          </h5>

          <button
            onClick={submitHandler}
            className="btn btn-success btn-sm mt-2"
          >
            Request Access
          </button>
        </div>

        <p className="mt-3" style={{ fontSize: "15px", lineHeight: "1.5" }}>
          Should you need any assistance or have a question, please email
          <a href="mailto:associate@logisticsnow.in" className="mx-1">
            associate@logisticsnow.in
          </a>
          or call
          <span className="ms-1">+91-9867773508 / +91-9653620207</span>
        </p>
      </div>
    </>
  );
};

const UpgradeModal = ({
  buttonLabel,
  activityName,
  moduleName,
  screenName,
  buttonClass,
  buttonTitle,
  feature,
  style,
  disabled,
}) => {

  return (
    <Modal2
      buttonLabel={buttonLabel}
      buttonClass={buttonClass}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      feature={feature}
      content={
        <NewUpgradeModal
          screenName={screenName}
          moduleName={moduleName}
          feature={feature}
        />
      }
      title={`Upgrade Now!`}
      id="editenquiry"
      screenName={screenName}
      moduleName={moduleName}
      activityName={activityName}
      backdrop={true}
      buttonTitle={buttonTitle}
      size="md"
      style={style}
      disabled={disabled}
    />
  );
};

export default UpgradeModal;
